import { useEffect, useState } from "react";
import { chatApi } from "../api";
import type { DatasourceOption } from "../types/chat";

export function useDatasourceOptions() {
  const [options, setOptions] = useState<DatasourceOption[]>([]);

  useEffect(() => {
    chatApi.listDatasources()
      .then((res) => setOptions(Array.isArray(res.data) ? res.data : []))
      .catch(() => setOptions([]));
  }, []);

  return options;
}
